<script setup lang="ts">
  import { EditorPageHeader } from '@/shared/ui/components'
  import PageDecorationImage from '@/shared/ui/components/PageDecorationImage.vue'

  import { EventsEditor } from '@/features/events'

  definePage({
    meta: {
      layout: 'baseNew',
      contentManagerRoute: true,
    },
  })

  const { t } = useI18n()

  useHead({
    title: () => t('events_create_page_title'),
  })
</script>

<template>
  <div class="wide-responsive relative flex w-full flex-col">
    <PageDecorationImage class="pointer-events-none absolute top-0 right-0" />

    <EditorPageHeader
      parent-route-name="/events/[[page]]"
      parent-label-key="navigation_item_announcements"
      :current-label="$t('events_breadcrumb_add')"
      data-testid="events-editor-page-header"
    />
    <EventsEditor />
  </div>
</template>
